export default "__VITE_ASSET__DLSXrGRp__"